import { CommercialPurchases } from '@/services/backend/products/commercial/purchases';
import { CommercialContracts } from '@/services/backend/products/commercial/contracts';
import { CommercialNotices } from '@/services/backend/products/commercial/notices';

export default {
    purchases: new CommercialPurchases(),
    contracts: new CommercialContracts(),
    notices: new CommercialNotices()
};
